import { Link } from 'react-router-dom';
import page from './Page.module.css';

export function NotFoundPage() {
  return (
    <div className={page.card} style={{ margin: 24 }}>
      <h2 className={page.title}>Page not found</h2>
      <p className={page.muted}>
        <Link to="/builders">Back to builders</Link>
      </p>
    </div>
  );
}
